// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"179":"03d21ad826f0ae1b6b54","540":"5d29bf721d7c436eea73","844":"9cb30bfe9471ab8a29d3","961":"aa4c5ca0be1123843af5"}[chunkId] + ".bundle.js";
};